import appConfig from '../config/appConfig';
import {selectIotDeviceType} from '../state/selectors/iotDevice';
import {getState} from '../state/store';
import deviceTypesService from './device/deviceTypesService';

//TODO: rename service

const isDeviceSupported = (type) =>
    (appConfig.getEnableOrdinarySupport() && deviceTypesService.isOrdinary(type)) ||
    (appConfig.getEnableCortezSupport() && deviceTypesService.isCortez(type)) ||
    (appConfig.getEnableSoyuzSupport() && deviceTypesService.isSoyuz(type)) ||
    (appConfig.getEnableVespucciSupport() && deviceTypesService.isVespucci(type)) ||
    (appConfig.getEnableOriginalOneSupport() && deviceTypesService.isOriginalOne(type)) ||
    (appConfig.getEnableOriginalDuoSupport() && deviceTypesService.isOriginalDuo(type)) ||
    (appConfig.getEnableP4Support() && deviceTypesService.isP4(type)) ||
    (appConfig.getEnableVoyagerSupport() && deviceTypesService.isVoyager(type)) ||
    (appConfig.getEnableDeltaSupport() && deviceTypesService.isDelta(type)) ||
    (appConfig.getEnableArianeSupport() && deviceTypesService.isAriane(type)) ||
    (appConfig.getEnableCosmosSupport() && deviceTypesService.isCosmos(type)) ||
    (appConfig.getEnableHermesPrimeSupport() && deviceTypesService.isHermesPrime(type)) ||
    (appConfig.getEnableHermesMidSupport() && deviceTypesService.isHermesMid(type)) ||
    (appConfig.getEnableJunoSupport() && deviceTypesService.isJuno(type));

const isDuoOrOriginalsDuoSupported = () => appConfig.getEnableOriginalDuoSupport() || appConfig.getEnableSoyuzSupport();

const isIccJourneyScreensEnabled = () => appConfig.getIsICCConsumerServiceEnabled();

const isTNCEnabled = () => appConfig.getIsTNCEnabled() && isIccJourneyScreensEnabled();

const isDeviceSupportedForceCheck = (isHolder) => {
    if (isHolder) return true;

    //use getState to check last actual state
    const deviceType = selectIotDeviceType(getState());

    return isDeviceSupported(deviceType);
};

export default {
    isDeviceSupported,
    isDeviceSupportedForceCheck,
    isDuoOrOriginalsDuoSupported,
    isIccJourneyScreensEnabled,
    isTNCEnabled,
};
